import { createStore } from 'vuex'

export default createStore({
  state: {
	access_token: '',
	refresh_token: '',
	userinfo: [],
	channelinfo: [],
	usermenulist: [],
	msg_company_list:[]
  },
  getters: {
	
  },
  mutations: {
	set_access_token(state, value){
		state.access_token = value;
	},
	set_refresh_token(state, value){
		state.refresh_token = value;
	},
	set_userinfo(state, value){
		state.userinfo = value;
	},
	set_channelinfo(state, value){
		state.channelinfo = value;
	},
	set_usermenulist(state, value){
		state.usermenulist = value;
	},
	set_msg_company_list(state, value){
		state.msg_company_list = value;
	}
  },
  actions: {
	
  },
  modules: {
	
  }
})
